import { render, staticRenderFns } from "./TruckWeightCapacityTable.vue?vue&type=template&id=aa89963a&scoped=true"
import script from "./TruckWeightCapacityTable.vue?vue&type=script&lang=js"
export * from "./TruckWeightCapacityTable.vue?vue&type=script&lang=js"
import style0 from "./TruckWeightCapacityTable.vue?vue&type=style&index=0&id=aa89963a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa89963a",
  null
  
)

export default component.exports